
<style scoped>
</style>

<template>
	<component :is="tag"
			   :contenteditable="contenteditable"
			   @input="update"
			   @blur="update"
			   @paste="onPaste"
			   @keypress="onKeypress"
			   @keydown="fwdEv"
			   @keyup="fwdEv"
			   @mouseenter="fwdEv"
			   @mouseover="fwdEv"
			   @mousemove="fwdEv"
			   @mousedown="fwdEv"
			   @mouseup="fwdEv"
			   @auxclick="fwdEv"
			   @click="fwdEv"
			   @dblclick="fwdEv"
			   @contextmenu="fwdEv"
			   @wheel="fwdEv"
			   @mouseleave="fwdEv"
			   @mouseout="fwdEv"
			   @select="fwdEv"
			   @pointerlockchange="fwdEv"
			   @pointerlockerror="fwdEv"
			   @dragstart="fwdEv"
			   @drag="fwdEv"
			   @dragend="fwdEv"
			   @dragenter="fwdEv"
			   @dragover="fwdEv"
			   @dragleave="fwdEv"
			   @drop="fwdEv"
			   @transitionstart="fwdEv"
			   @transitioncancel="fwdEv"
			   @transitionend="fwdEv"
			   @transitionrun="fwdEv"
			   @compositionstart="fwdEv"
			   @compositionupdate="fwdEv"
			   @compositionend="fwdEv"
			   @cut="fwdEv"
			   @copy="fwdEv"
			   ref="element">
	</component>
</template>

<script>
	/*
MIT License

Copyright (c) 2018 Léo Flaventin Hauchecorne

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
	*/
	function replaceAll(str, search, replacement)
	{
		return str.split(search).join(replacement);
	};

	export default {
		name: 'contenteditable',
		props: {
			'tag': String,
			'contenteditable': {
				type: Boolean,
				default: true,
			},
			'modelValue': String,
			'noHtml': {
				type: Boolean,
				default: true,
			},
			'noNl': {
				type: Boolean,
				default: false,
			},
		},
		// Declaring emits prevents Vue 3's attribute fallthrough from ALSO attaching these as native
		// event listeners on the root element, which would cause each forwarded event to fire twice.
		emits: ['update:modelValue', 'returned',
			'paste', 'keypress', 'keydown', 'keyup', 'mouseenter', 'mouseover', 'mousemove', 'mousedown', 'mouseup',
			'auxclick', 'click', 'dblclick', 'contextmenu', 'wheel', 'mouseleave', 'mouseout', 'select',
			'pointerlockchange', 'pointerlockerror', 'dragstart', 'drag', 'dragend', 'dragenter', 'dragover',
			'dragleave', 'drop', 'transitionstart', 'transitioncancel', 'transitionend', 'transitionrun',
			'compositionstart', 'compositionupdate', 'compositionend', 'cut', 'copy'],
		mounted()
		{
			this.update_content(this.modelValue);
		},
		computed: {
		},
		data()
		{
			return {
			}
		},
		methods: {
			current_content()
			{
				return this.noHtml ?
					this.$refs.element.innerText
					:
					this.$refs.element.innerHTML;
			},
			update_content(newcontent)
			{
				if (this.noHtml)
				{
					this.$refs.element.innerText = newcontent;
				}
				else
				{
					this.$refs.element.innerHTML = newcontent;
				}
			},
			update(event)
			{
				this.$emit('update:modelValue', this.current_content());
			},
			onPaste(event)
			{
				event.preventDefault();
				let text = (event.originalEvent || event).clipboardData.getData('text/plain');
				if (this.noNl)
				{
					text = replaceAll(text, '\r\n', ' ');
					text = replaceAll(text, '\n', ' ');
					text = replaceAll(text, '\r', ' ');
				}
				window.document.execCommand('insertText', false, text);
				this.fwdEv(event)
			},
			onKeypress(event)
			{
				if (event.key == 'Enter' && this.noNl)
				{
					event.preventDefault();
					this.$emit('returned', this.current_content);
				}
				this.fwdEv(event)
			},
			fwdEv(event)
			{
				this.$emit(event.type, event);
			}
		},
		watch: {
			modelValue(newval, oldval)
			{
				if (newval != this.current_content())
				{
					this.update_content(newval);
				}
			}
		}
	}
</script>
